const flattenFilters = (filters: any[]): any[] => {
    const result: any[] = []
  
    const traverse = (items: any[]) => {
      for (const item of items) {
        result.push(item)
        if (Array.isArray(item.filters) && item.filters.length > 0) {
          traverse(item.filters)
        }
      }
    }
  
    traverse(filters)
  
    return result
  }

  export default flattenFilters